import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import {Button, Card, Table, Tag} from "antd";
import Colors from "../../styles/Colors";
import {BiAlarm, BiAlarmOff, BiPencil, BiPlus, BiRefresh, BiTrash, BiWorld} from "react-icons/bi";
import {ColumnsType, TableProps} from "antd/es/table";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import LlocTreball from "../../model/root/LlocTreball";
import {GetLlocTreball} from "../../dao/root/GetLlocTreball";
import LlocDeTreballModal from "./component/LlocDeTreballModal";
import Login from "./Login";
import {PostLlocTreball} from "../../dao/root/PostLlocTreball";
import {GetControlHorari} from "../../dao/root/GetControlHorari";
import ControlHorari from "../../model/root/ControlHorari";
import {format} from "date-fns";
import controlHorari from "../../model/root/ControlHorari";
import dayjs from "dayjs";
import {PostControlHorari} from "../../dao/root/PostControlHorari";
import ControlHorariModal from "./component/ControlHorariModal";
import {defaultUser, User} from "../../model/root/User";
import {GetUsuaris} from "../../dao/root/GetUsuaris";

const HorarisTreball = () => {
    const titol: string = "Horari de Treball";
    const nomPermis: string = "Control Horari";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();
    const {id_usuari, empresa} = useParams();


    const [options, setOptions] = useState<{ label: string; value: string; }[]>([{
        label: "",
        value: ""
    }]);

    const [coleccio, setDades] = useState<ControlHorari[]>([]);
    const [llocSelected, setLlocSelected] = useState<ControlHorari>(new ControlHorari());
    const [loading, setLoading] = useState(false);
    const [elementSelected, setElementSelected] = useState<ControlHorari>(new ControlHorari());
    const [nouElement, setNouElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);
    const [nouLloc, setNouLloc] = useState(false);
    const [usuaris, setUsuaris] = useState<User[]>([]);
    const [update, setUpdate] = useState(false);
    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());


    useEffect(() => {
        if(isLoggedIn){
            handleLoadingChange(true)
            checkDades();
        }
    }, [id, elementSelected]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetControlHorari(empresa || page, id_usuari === null ? '' : id_usuari+"");
        setDades(dades);
        const usuaris = await GetUsuaris(page);
        console.log(JSON.stringify(usuaris));
        setUsuarisOptions(usuaris.usuaris);
        const opts = await GetLlocTreball(page);
        setLlocsOptions(opts);
        await handleLoadingChange(false);
    }


    function setUsuarisOptions(usuaris: User[]) {
        if (usuaris && usuaris?.length) {
            const options = usuaris.map(contact => ({
                label: `${contact.nom}`,
                value: contact.id + ""
            }));
            setOptions(options);
        }
    }

    function toggleTable() {
        setVisible(!visible);
    }

    function togleNouElement(element: ControlHorari) {
        setNouElement(!nouElement);
        const modified: controlHorari = {
            ...element,
            entrada: dayjs(element.entrada),
            sortida: dayjs(element.sortida)
        };
        console.log(JSON.stringify(element));
        setElementSelected(modified);
        setUpdate(true);
    }

    function desactivarElement(element: ControlHorari) {
        const modified: controlHorari = {
            ...element,
            estat: (element.estat === 0 ? 1 : 0)
        };
        handleCloseModal(modified, true);
    }

    async function handleCloseModal(element: ControlHorari, guardar: boolean) {
        setNouElement(false);
        if (guardar) {
            setLoading(true);
            await PostControlHorari(element, page);
            await checkDades();
        }
    }

    async function deleteElement(element: ControlHorari) {
        const modified: controlHorari = {
            ...element,
            estat: -1
        };
        handleCloseModal(modified, true);
    }


    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    const columns:  ColumnsType<ControlHorari> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'entrada',
            title: 'Entrada',
            dataIndex: 'entrada',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color1}>{ele.entrada+""}</Tag>
            )
        },
        {
            key: 'sortida',
            title: 'Sortida',
            dataIndex: 'sortida',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color2}>{ele.sortida + ""}</Tag>
            )
        },
        {
            key: 'lloc',
            title: 'Lloc de treball',
            dataIndex: 'lloc',
            width: 30,
            render: (estat, ele) =>(
                (ele.lloc === 'Itinerant' && <Tag color={Colors.colors.color4}>{ele.lloc}</Tag>) || (ele.lloc !== 'Itinerant' && ele.lloc)
            )

        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 100,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Invalidar"} style={ele.estat === 0 ? {backgroundColor: Colors.colors.color3}
                                : {backgroundColor: Colors.colors.color1}}
                                    onClick={() => desactivarElement(ele)}>{ele.estat === 0 ? <BiAlarmOff/> :
                                <BiAlarm/>}</Button>{" "}
                            <Button title={"Modificar"} style={{backgroundColor: Colors.colors.color4}}
                                    onClick={() => togleNouElement(ele)}><BiPencil/></Button>{" "}
                            <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}
                                    onClick={() => deleteElement(ele)}><BiTrash/></Button>
                        </>
                    )}
                </>
            ),
        },
    ];


    function setLlocsOptions(llocs: LlocTreball[]) {
        if (llocs && llocs?.length) {
            const options = llocs.map(lloc => ({
                label: `${lloc.nom}`,
                value: lloc.id + ""
            }));
            setOptions2(options);
        }
    }


    const tableProps: TableProps<ControlHorari> = {
        loading
    };

    const onChange: TableProps<ControlHorari>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const [options2, setOptions2] = useState<{ label: string; value: string; }[]>([{
        label: "",
        value: ""
    }]);

    function afegirLloc(control: ControlHorari) {
        setLlocSelected({...control, id: id_usuari !== null ? parseInt(id_usuari+"") : 0});
        setUpdate(id_usuari !== null ? true : false);
        setNouElement(true);
        setNouLloc(true);
    }

    async function handleLlocModalClose(element: ControlHorari, guardar: boolean) {
        setNouLloc(false);
        if (guardar) {
            setLoading(true);
            await PostLlocTreball(element, page);
            await checkDades();
        }
    }

    async function deleteLloc(element: ControlHorari) {
        const modified: ControlHorari = {
            ...element,
            estat: -1
        };
        handleLlocModalClose(modified, true);
    }

    const redirigirANuevaPestana = () => {
        window.open('https://www.coordenadas-gps.com/', '_blank');
    };

    if (isLoggedIn) {
        return (
            <>
                <Card bordered={true} className={"elemento"}>
                    <div className={"actionButtons"}>
                        {false && permisosEdicio &&
                            <>
                                <Button title={"Nou Lloc"} style={{backgroundColor: Colors.colors.color2}}
                                        onClick={() =>
                                            afegirLloc(new ControlHorari())}><BiPlus/></Button>
                            </>
                        }
                        <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color5}} onClick={() =>
                            checkDades()}><BiRefresh/></Button>
                    </div>
                    <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                    {visible && (
                        <Table
                            {...tableProps}
                            onChange={onChange}
                            columns={columns}
                            dataSource={coleccio}
                        />
                    )}
                </Card>
                {nouLloc && (
                    <ControlHorariModal element={elementSelected} onClose={handleCloseModal}
                                        visible={nouElement} options={options} usuaris={usuaris}
                                        update={update} llocsTreball={options2}/>
                )}
            </>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default HorarisTreball;
